import React from 'react';
//import compose from 'recompose/compose';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { stringify } from 'query-string';

import processing from '../processing';

const styles = {
    icon: { paddingRight: '0.5em' },
    link: {
        display: 'inline-flex',
        alignItems: 'center',
    },
};

const LinkToProcessing = ({ classes, record, brcode }) => (
    //console.log(loc),
    <Button
        size="small"
        color="primary"
        component={Link}
        to={{
            pathname: '/processing',
            search: stringify({
                page: 1,
                perPage: 25,
                sort: 'id',
                order: 'DESC',
                filter: JSON.stringify({ ssn: record.ssn,branch_code: brcode}),
            }),
        }}
        className={classes.link}
    >
        <processing.icon className={classes.icon} />Processing
    </Button>
);
/*
const enhance = compose(
    withStyles(styles),
    
);
*/
export default withStyles(styles)(LinkToProcessing);